<template>
  <a-layout class="index animated fadeIn s_bf">
    <a-card :bordered="false">
      <div class="m-b-25">
        <span class="mr15">
          <a-button
            type="primary"
            v-has:addPlaySetAgencyPaymentBrand="createDataOnClick"
          >
            <PlusOutlined />
            添加代发品牌商
          </a-button>
        </span>
      </div>
      <div class="m-t-25">
        <a-form
          ref="form"
          class="m-t-20"
          :model="searchCp.data"
          :initialValues="searchCp.data"
          :onFinish="searchOnSubmit"
          layout="inline"
        >
          <a-form-item label="品牌商">
            <a-input
              style="width: 300px"
              v-model:value="searchCp.data.keyword"
              placeholder="请输入品牌商编号、名称"
            />
          </a-form-item>
          <a-form-item>
            <a-button type="primary" htmlType="submit" class="m-r-10"
              >搜索</a-button
            >
          </a-form-item>
        </a-form>
        <a-table
          :pagination="false"
          :loading="pageData.loading"
          bordered
          rowKey="id"
          :columns="tableCp.columns"
          :data-source="pageData.data"
          class="tableFixBox mt-25"
          :scroll="{ x: 'max-content' }"
        >
          <template v-slot:action="{ record }">
            <a-button
              size="small"
              type="primary"
              v-has:updatePlaySetAgencyPaymentBrand="
                () => {
                  editPageDataOnClick(record);
                }
              "
              class="m-r-5"
              >编辑</a-button
            >
            <a-button
              size="small"
              type="primary"
              danger
              v-has:updatePlaySetAgencyPaymentBrand="
                () => {
                  deletePageDataOnClick(record);
                }
              "
              class="m-r-5"
              >删除</a-button
            >
          </template>
        </a-table>
        <a-pagination
          :style="{ marginTop: '20px', textAlign: 'right' }"
          show-size-changer
          show-quick-jumper
          :current="pageData.page"
          :page-size="pageData.perPageCount"
          :total="pageData.total"
          @change="pageOnChange"
          @showSizeChange="pageSizeOnChange"
          :show-total="(total) => `总数: ${total} `"
        />
      </div>
    </a-card>
  </a-layout>

  <!-- 添加/修改 start -->
  <a-modal
    :keyboard="false"
    :title="createCp.data.id ? '修改代发品牌商' : '添加代发品牌商'"
    centered
    v-model:visible="createCp.show"
    @ok="createDataOnSubmit"
    destroyOnClose
  >
    <a-form
      :rules="createCp.rules"
      ref="createFormRef"
      :model="createCp.data"
      :label-col="{ span: 4 }"
      :wrapper-col="{ span: 20 }"
    >
      <a-form-item label="品牌商" name="brand_id">
        <div class="flex items-center">
          <a-input
            v-model:value="createCp.data.brand_name"
            placeholder="请选择品牌商"
            readonly
          />
          <a-button
            v-if="!createCp.data.id"
            type="primary"
            class="ml-10"
            @click="brandCp.show = true"
            >选择</a-button
          >
        </div>
      </a-form-item>
      <a-form-item label="代发配置" name="behalf_config_id">
        <selectAgencyPaymentConfig
          v-model:value="createCp.data.behalf_config_id"
        ></selectAgencyPaymentConfig>
      </a-form-item>
    </a-form>
  </a-modal>
  <!-- 添加/修改 end -->

  <!-- 品牌商弹窗 -->
  <a-modal
    v-model:visible="brandCp.show"
    title="品牌商"
    :width="1200"
    destroyOnClose
    centered
    :footer="null"
  >
    <selectBrand
      v-on:select="brandOnSelect"
      :checkout="false"
      :selectList="[]"
    />
  </a-modal>
</template>
<script>
import { PlusOutlined, InboxOutlined } from "@ant-design/icons-vue";
import { ref, onMounted, inject, reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import { $iscode } from "@/utils/app";
import {
  getAgencyPaymentBrandList,
  addAgencyPaymentBrand,
  updateAgencyPaymentBrand,
  deleteAgencyPaymentBrand
} from "@/api/system";

export default {
  name: "agencyPaymentBrand",
  components: {
    PlusOutlined
  },
  setup(props, ctx) {
    const $route = inject("$route");
    const $Modal = inject("$Modal");
    const $store = inject("$store");
    let pageDatum = reactive({
      info: $store.state.user.info
    });

    /* 搜索 start */
    const searchCp = reactive({
      data: {
        keyword: ""
      }
    });
    // 搜索提交
    const searchOnSubmit = (e) => {
      resetPageData();
      getPageData(gainParamData());
    };

    // 时间
    const searchTimeCp = reactive({
      time: []
    });
    // 搜索时间修改
    const searchTimeOnChange = () => {
      searchCp.data.s_time = searchTimeCp.time[0];
      searchCp.data.e_time = searchTimeCp.time[1];
      getPageData(gainParamData());
    };

    /* 搜索 end */

    /* 页面数据 start */
    let pageData = reactive({
      loading: false,
      // 当前第几页
      page: 1,
      // 每页数量，默认一页10条
      perPageCount: 10,
      // 总页数
      pageCount: 1,
      // 总条数，跟pageCount二选一就行
      total: 1,
      data: [],
      // 当前选中的
      currentData: {}
    });
    // 表单配置
    const tableCp = reactive({
      columns: [
        {
          title: "品牌商编号",
          dataIndex: "brand_id",
          key: "brand_id"
        },
        {
          title: "公司名称",
          dataIndex: "brand_name",
          key: "brand_name"
        },
        {
          title: "代发配置",
          dataIndex: "behalf_config_name",
          key: "behalf_config_name"
        },
        {
          title: "操作",
          dataIndex: "action",
          key: "action",
          slots: { customRender: "action" }
        }
      ]
    });
    // 清空数据
    const emptyPageData = () => {
      pageData.data = [];
    };
    // 重置数据
    const resetPageData = () => {
      emptyPageData();
      pageData.loading = false;
      pageData.lock = false;
      pageData.page = 1;
    };
    // 获取页面数据
    const getPageData = async (paramData = {}) => {
      if (pageData.loading) {
        return;
      }
      pageData.loading = true;
      emptyPageData();
      let result = await getAgencyPaymentBrandList(paramData)
        .then((res) => res.data)
        .catch((error) => error);
      pageData.loading = false;
      if ($iscode(result, true, false)) {
        let respData = result.data || [];
        let respList = respData.data || [];
        pageData.data = respList || [];
        pageData.total = respData.total || 0;
      }
    };
    // 修改当前页
    const pageOnChange = (e) => {
      pageData.page = e;
      getPageData(gainParamData());
    };
    // 修改每页显示多少行
    const pageSizeOnChange = (currentPage, perPageCount) => {
      resetPageData();
      pageData.perPageCount = perPageCount;
      getPageData(gainParamData());
    };

    /* 页面数据 end */
    // 获取getPageData需要的数据
    const gainParamData = () => {
      // 转换搜索数据
      let searchData = {
        ...searchCp.data
      };
      // 转换分页数据
      let paginationData = {
        page: pageData.page,
        limit: pageData.perPageCount
      };
      return {
        ...searchData,
        ...paginationData
      };
    };
    // 删除;
    const deletePageDataOnClick = (record) => {
      $Modal.confirm({
        centered: true,
        title: "删除提示",
        content: "确定删除吗？",
        async onOk() {
          let res = await deleteAgencyPaymentBrand({
            id: record.id
          }).then((res) => res.data);
          if ($iscode(res)) {
            getPageData(gainParamData());
            message.success(res.msg);
          } else {
            message.error(res.msg);
          }
        }
      });
    };
    /* 添加/修改 start */
    const createOriginData = {
      brand_id: "",
      behalf_config_id: ""
    };
    const createFormRef = ref("");
    const createCp = reactive({
      show: false,
      loading: false,
      data: {
        ...createOriginData
      },
      rules: {
        brand_id: [{ required: true, message: "请选择品牌商" }],
        behalf_config_id: [{ required: true, message: "请选择代发配置" }]
      }
    });
    const resetCreateData = () => {
      createCp.data = { ...createOriginData };
    };
    // 新增
    const createDataOnClick = () => {
      resetCreateData();
      createCp.show = true;
    };
    // 修改
    const editPageDataOnClick = (data) => {
      createCp.data = {
        ...data
      };
      createCp.show = true;
    };
    const createDataOnSubmit = () => {
      if (createCp.loading) {
        return;
      }
      createFormRef.value
        .validate()
        .then(() => {
          submitPageData();
        })
        .catch((error) => {
          console.log("error", error);
        });
    };
    const submitPageData = () => {
      if (createCp.loading) {
        return;
      }
      if (createCp.data.id) {
        updatePageData();
      } else {
        addPageData();
      }
    };
    const addPageData = async () => {
      createCp.loading = true;
      const paramData = {
        ...createCp.data
      };
      let result = await addAgencyPaymentBrand(paramData)
        .then((res) => res.data)
        .catch((error) => error);
      createCp.loading = false;
      if ($iscode(result, true, true)) {
        createCp.show = false;
        getPageData(gainParamData());
      }
    };
    const updatePageData = async () => {
      createCp.loading = true;
      const paramData = {
        ...createCp.data
      };
      let result = await updateAgencyPaymentBrand(paramData)
        .then((res) => res.data)
        .catch((error) => error);
      createCp.loading = false;
      if ($iscode(result, true, true)) {
        createCp.show = false;
        getPageData(gainParamData());
      }
    };
    /* 添加/修改 end */
    const brandCp = reactive({
      show: false,
      data: {}
    });
    const brandOnSelect = (e) => {
      brandCp.data = e;
      createCp.data.brand_name = e.brand_name;
      createCp.data.brand_id = e.brand_no;
      brandCp.show = false;
    };

    onMounted(() => {
      if ($route.query.page) {
        pageData.page = $route.query.page;
      }
      getPageData(gainParamData());
    });

    return {
      pageDatum,
      // 搜索相关数据和操作
      searchCp,
      searchOnSubmit,
      searchTimeCp,
      searchTimeOnChange,
      // 页面相关数据和操作
      pageData,
      tableCp,
      pageOnChange,
      pageSizeOnChange,
      // 新增修改
      createCp,
      createFormRef,
      createDataOnSubmit,
      createDataOnClick,
      editPageDataOnClick,
      deletePageDataOnClick,
      brandCp,
      brandOnSelect
    };
  }
};
</script>
